module.exports = __webpack_public_path__ + "static/img/11.654a793.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/11.png
// module id = 8VCc
// module chunks = 0